import { Step } from '../../../core/domain/transaction/step';

export const EmptyStep = () =>
	new Step({}, async () => {
		return {
			wasSuccessful: true
		};
	});
